import { ArrowUpRight, Check, ShieldCheck } from "lucide-react";
import { CHECKOUT_URL, PRICE } from "@/config";
import { Reveal } from "@/components/Reveal";

const stack = [
  "E-book completo em PDF — 15 capítulos",
  "Linguagem acessível e visual",
  "Checklist prático de cuidados",
  "Plano de apoio individual para preencher",
  "Perguntas frequentes respondidas",
  "Leitura em celular, tablet ou computador",
];

export default function Offer() {
  return (
    <section id="comprar" className="bg-navy text-white">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 py-24 md:grid-cols-[1fr_0.85fr] md:px-12 md:py-32">
        <Reveal>
          <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.22em] text-sun">
            Acesso digital imediato
          </p>
          <h2 className="mb-6 font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
            Comece hoje a cuidar com mais informação.
          </h2>
          <p className="mb-8 max-w-lg text-base leading-relaxed text-white/70 sm:text-lg">
            Um material organizado, visual e fácil de consultar sempre que precisar —
            para transformar conhecimento em acolhimento no dia a dia.
          </p>
          <div className="flex items-center gap-3 text-sm font-bold text-white/80">
            <ShieldCheck className="h-5 w-5 text-sun" />
            Compra segura pela plataforma de pagamento • Acesso imediato após a confirmação
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div
            data-testid="offer-card"
            className="rounded-[2rem] bg-white p-8 text-navy shadow-[0_32px_80px_-20px_rgba(0,0,0,0.5)] md:p-10"
          >
            <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-ink">
              E-book digital
            </p>
            <div className="mt-3 flex items-end gap-2">
              <span data-testid="offer-price" className="font-display text-6xl font-black tracking-tight">
                {PRICE}
              </span>
              <span className="pb-2 text-sm font-bold text-ink">pagamento único</span>
            </div>
            <ul className="my-7 space-y-3 border-t border-navy/10 pt-7">
              {stack.map((s) => (
                <li key={s} className="flex gap-3 text-sm font-semibold text-ink">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-green-600" strokeWidth={3} />
                  {s}
                </li>
              ))}
            </ul>
            <a
              data-testid="buy-button"
              href={CHECKOUT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex w-full items-center justify-center gap-2 rounded-full bg-flame px-8 py-4 text-sm font-extrabold uppercase tracking-wide text-white transition-all duration-200 hover:scale-[1.03] hover:bg-[#c2410c]"
            >
              Comprar agora
              <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <p className="mt-4 text-center text-xs text-ink/70">
              Formato PDF digital • Envio imediato após a confirmação do pagamento
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
